<template>
<div>
  <v-dialog @click:outside="close" v-model="dialog" width="850" persistent>
    <v-card outlined class="v-card-outline-primary" elevation="3">
      <v-card-title>
        <h5 class="primary--text">{{ $t("common.details") }}</h5>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <label>{{ $t("fleet.roads.selectVehicle") }}</label>
        <v-select v-model="selectedVehicle" :items="vehicles" item-text="name" item-value="id" dense @change="vehicleChange" outlined></v-select>
        <label>{{ $t("fleet.roads.selectRoad") }}</label>
        <v-select v-model="selectedRoad" :items="roads" :item-text="
              (item) =>
                item.firstLoading +
                ' - ' +
                item.lastUnloadng +
                ' (' +
                item.pointsCounter +
                ')'
            " item-value="id" dense outlined :disabled="selectedVehicle == null"></v-select>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined min-width="120" @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn :disabled="selectedVehicle == null && roads.length < 5" color="primary" outlined min-width="120" @click="confirmNew">
            {{ $t("fleet.roads.addRoad") }}
          </v-btn>
          <v-btn :disabled="selectedRoad == null" color="primary" outlined min-width="120" @click="confirm">
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import Service from '@/services'

export default {
  components: {},
  data () {
    return {
      vehicles: [],
      roads: [],
      selectedVehicle: null,
      selectedRoad: null,
      orderId: null,
      dialog: false
    }
  },
  methods: {
    async open (orderId) {
      this.dialog = true
      this.orderId = orderId
      const {
        data
      } = await Service.get(
        'Fleet/GetVehicles?page=1&pageSize=100&'
      )
      this.vehicles = data.results
    },
    async vehicleChange () {
      const {
        data
      } = await Service.get('road/getroad', {
        vehicleId: this.selectedVehicle
      })
      this.roads = data.results
    },
    async confirmNew () {
      await Service.put('road/AddPointsFromOrder', {
        orderId: this.orderId,
        vehicleId: this.selectedVehicle
      })
      this.close()
    },
    async confirm () {
      await Service.put('road/AddPointsFromOrder', {
        orderId: this.orderId,
        roadId: this.selectedRoad
      })
      this.close()
    },
    close () {
      this.points = null
      this.dialog = false
      this.selectedRoad = null
      this.selectedVehicle = null
      this.orderId = null
      this.vehicles = []
      this.roads = []
    }
  }
}
</script>

<style></style>
